import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AccountState {
  technician: string;
}

const initialState: AccountState = {
  technician: '',
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setTechnician(state, action: PayloadAction<string>) {
      state.technician = action.payload;
    },
    clearTechnician(state) {
      state.technician = initialState.technician;
    },
  },
});

export const accountActions = accountSlice.actions;

const accountReducer = accountSlice.reducer;

export default accountReducer;
